import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionExpiryService {
  readonly expired = signal(false);
  private shown = false;

  markExpired(): void {
    if (this.shown) {
      return;
    }
    this.shown = true;
    this.expired.set(true);
  }

  acknowledge(): void {
    this.expired.set(false);
  }
}
